
  import AuthorsPageView from '@/components/views/AuthorsPageView'

  export default {
    name: 'AuthorsPage',
    components: { AuthorsPageView },
    data() {
      return {}
    },
    head() {
      return {
        title: `Список авторов и правообладателей сервиса Musicat.store, разместивших свою лицензионную музыку`,
        meta: [
          {
            hid: 'description',
            name: 'description',
            content: `Здесь представлены авторы и правообладатели, размещающие лицензионную музыку для видео, рекламы, радио, телевидения, кино, компьютерных игр и заведений.`,
          },
          {
            hid: 'keywords',
            name: 'keywords',
            content: `Автор, Авторы, правообладатели, лицензионная музыка, авторы музыки, купить музыку, скачать музыку, Wav, купить лицензионную музыку, музыка для бизнеса,`,
          },
        ],
      }
    },
    watch: {
      '$route.query.page': {
        handler() {
          if (process.client) window.scrollTo(0,0)
          this.getAuthors()
        },
        deep: true,
        immediate: true,
      }
    },
    mounted() {
      this.getAuthors()
    },
    methods: {
      getAuthors() {
        const page = parseInt(this.$route.query.page)
        const { ordering } = this.$route.query
        const params = ordering ? {
            page: page && !isNaN(page) ? page : 1,
            ordering,
          } : { page: page && !isNaN(page) ? page : 1 }
        this.$store.dispatch('author/getAuthors', params)
        }
    },
  }
